@if (collection) {
  <h2 class="visually-hidden">{{ "forms.collection.preview.title" | translate }}</h2>
  <ng-container>
    <h3>{{ "forms.collection.preview.headings.basic" | translate }}</h3>
    <dl class="row g-0">
      @if (hasName) {
        <dt class="col-sm-3">{{ "forms.collection.basic.name.label" | translate }}</dt>
        <dd class="col-sm-9">{{ previewCollection.name }}</dd>
      } @else {
        <dt class="col-sm-3">{{ "forms.collection.preview.required.name" | translate }}</dt>
        <dd class="col-sm-9">
          <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
          <a [routerLink]="['/kokoelma', collectionId, 'muokkaa', 1]">
            {{ "forms.collection.preview.addMissingDetail" | translate }}
          </a>
        </dd>
      }
      <!--name-->
      <!--missingName-->
      @if (hasKeywords) {
        <dt class="col-sm-3">{{ "forms.collection.basic.keywords.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (keyword of previewCollection.keywords; track keyword; let isLast = $last) {
            {{ keyword.value }}{{ isLast ? "" : ", " }}
          }
        </dd>
      } @else {
        <dt class="col-sm-3">{{ "forms.collection.preview.required.keywords" | translate }}</dt>
        <dd class="col-sm-9">
          <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
          <a [routerLink]="['/kokoelma', collectionId, 'muokkaa', 1]">
            {{ "forms.collection.preview.addMissingDetail" | translate }}
          </a>
        </dd>
      }
      <!--keywords-->
      <!--missingKeywords-->
      @if (previewCollection.educationalRoles?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.basic.educationalRoles.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (role of previewCollection.educationalRoles; track role; let isLast = $last) {
            {{ role.value }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--educationalRoles-->
      @if (previewCollection.educationalUses?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.basic.educationalUses.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (use of previewCollection.educationalUses; track use; let isLast = $last) {
            {{ use.value }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--educationalUses-->
      @if (previewCollection.languages?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.basic.languages.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (language of previewCollection.languages; track language; let isLast = $last) {
            {{ language }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--languages-->
      @if (previewCollection.accessibilityFeatures?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.basic.accessibilityFeatures.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (feature of previewCollection.accessibilityFeatures; track feature; let isLast = $last) {
            {{ feature.value }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--accessibilityFeatures-->
      @if (previewCollection.accessibilityHazards?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.basic.accessibilityHazards.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (hazard of previewCollection.accessibilityHazards; track hazard; let isLast = $last) {
            {{ hazard.value }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--accessibilityHazards-->
      @if (hasDescription) {
        <dt class="col-sm-3">{{ "forms.collection.basic.description.label" | translate }}</dt>
        <dd class="col-sm-9">{{ previewCollection.description }}</dd>
      } @else {
        <dt class="col-sm-3">{{ "forms.collection.preview.required.description" | translate }}</dt>
        <dd class="col-sm-9">
          <span class="bg-danger p-1 me-2">{{ "forms.common.required" | translate }}</span>
          <a [routerLink]="['/kokoelma', collectionId, 'muokkaa', 1]">
            {{ "forms.collection.preview.addMissingDetail" | translate }}
          </a>
        </dd>
      }
      <!--description-->
      <!--missingDescription-->
    </dl>
    <hr />
  </ng-container>
  <!--basic details-->
  <ng-container>
    <h3>{{ "forms.collection.preview.headings.educational" | translate }}</h3>
    <dl class="row g-0">
      @if (previewCollection.educationalLevels?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.educationalLevels.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (level of previewCollection.educationalLevels; track level; let isLast = $last) {
            {{ level.value }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--educationalLevels-->
      @if (previewCollection.earlyChildhoodEducationSubjects?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.earlyChildhoodEducationSubjects.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (subject of previewCollection.earlyChildhoodEducationSubjects; track subject; let isLast = $last) {
            {{ subject.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--earlyChildhoodEducationSubjects-->
      @if (previewCollection.earlyChildhoodEducationObjectives?.length > 0) {
        <dt class="col-sm-3">
          {{ "forms.collection.educational.earlyChildhoodEducationObjectives.label" | translate }}
        </dt>
        <dd class="col-sm-9">
          @for (objective of previewCollection.earlyChildhoodEducationObjectives; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--earlyChildhoodEducationObjectives-->
      @if (previewCollection.earlyChildhoodEducationFramework) {
        <dt class="col-sm-3">
          {{ "forms.collection.educational.earlyChildhoodEducationFramework.label" | translate }}
        </dt>
        <dd class="col-sm-9">{{ previewCollection.earlyChildhoodEducationFramework }}</dd>
      }
      <!--earlyChildhoodEducationFramework-->
      @if (previewCollection.prePrimaryEducationSubjects?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.prePrimaryEducationSubjects.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (subject of previewCollection.prePrimaryEducationSubjects; track subject; let isLast = $last) {
            {{ subject.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--prePrimaryEducationSubjects-->
      @if (previewCollection.prePrimaryEducationObjectives?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.prePrimaryEducationObjectives.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (objective of previewCollection.prePrimaryEducationObjectives; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--prePrimaryEducationObjectives-->
      @if (previewCollection.prePrimaryEducationFramework) {
        <dt class="col-sm-3">{{ "forms.collection.educational.prePrimaryEducationFramework.label" | translate }}</dt>
        <dd class="col-sm-9">{{ previewCollection.prePrimaryEducationFramework }}</dd>
      }
      <!--prePrimaryEducationFramework-->
      @if (previewCollection.basicStudySubjects?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.basicStudySubjects.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (subject of previewCollection.basicStudySubjects; track subject; let isLast = $last) {
            {{ subject.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--basicStudySubjects-->
      @if (previewCollection.basicStudyObjectives?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.basicStudyObjectives.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (objective of previewCollection.basicStudyObjectives; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--basicStudyObjectives-->
      @if (previewCollection.basicStudyContents?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.basicStudyContents.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (content of previewCollection.basicStudyContents; track content; let isLast = $last) {
            {{ content.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--basicStudyContents-->
      @if (previewCollection.basicStudyFramework) {
        <dt class="col-sm-3">{{ "forms.collection.educational.basicStudyFramework.label" | translate }}</dt>
        <dd class="col-sm-9">{{ previewCollection.basicStudyFramework }}</dd>
      }
      <!--basicStudyFramework-->
      @if (previewCollection.preparatoryEducationSubjects?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.preparatoryEducationSubjects.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (subject of previewCollection.preparatoryEducationSubjects; track subject; let isLast = $last) {
            {{ subject.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--preparatoryEducationSubjects-->
      @if (previewCollection.preparatoryEducationObjectives?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.preparatoryEducationObjectives.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (objective of previewCollection.preparatoryEducationObjectives; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--preparatoryEducationObjectives-->
      @if (previewCollection.upperSecondarySchoolSubjectsOld?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.upperSecondarySchoolSubjects.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (subject of previewCollection.upperSecondarySchoolSubjectsOld; track subject; let isLast = $last) {
            {{ subject.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--upperSecondarySchoolSubjectsOld-->
      @if (previewCollection.upperSecondarySchoolCoursesOld?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.upperSecondarySchoolCourses.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (course of previewCollection.upperSecondarySchoolCoursesOld; track course; let isLast = $last) {
            {{ course.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--upperSecondarySchoolCoursesOld-->
      @if (previewCollection.upperSecondarySchoolObjectives?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.upperSecondarySchoolObjectives.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (objective of previewCollection.upperSecondarySchoolObjectives; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--upperSecondarySchoolObjectives-->
      @if (previewCollection.upperSecondarySchoolFramework) {
        <dt class="col-sm-3">{{ "forms.collection.educational.upperSecondarySchoolFramework.label" | translate }}</dt>
        <dd class="col-sm-9">{{ previewCollection.upperSecondarySchoolFramework }}</dd>
      }
      <!--upperSecondarySchoolFramework-->
      @if (previewCollection.upperSecondarySchoolSubjectsNew?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.upperSecondarySchoolSubjectsNew.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (subject of previewCollection.upperSecondarySchoolSubjectsNew; track subject; let isLast = $last) {
            {{ subject.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--upperSecondarySchoolSubjectsNew-->
      @if (previewCollection.upperSecondarySchoolModulesNew?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.upperSecondarySchoolModulesNew.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (module of previewCollection.upperSecondarySchoolModulesNew; track module; let isLast = $last) {
            {{ module.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--upperSecondarySchoolModulesNew-->
      @if (previewCollection.upperSecondarySchoolObjectivesNew?.length > 0) {
        <dt class="col-sm-3">
          {{ "forms.collection.educational.upperSecondarySchoolObjectivesNew.label" | translate }}
        </dt>
        <dd class="col-sm-9">
          @for (objective of previewCollection.upperSecondarySchoolObjectivesNew; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--upperSecondarySchoolObjectivesNew-->
      @if (previewCollection.upperSecondarySchoolContentsNew?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.upperSecondarySchoolContentsNew.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (content of previewCollection.upperSecondarySchoolContentsNew; track content; let isLast = $last) {
            {{ content.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--upperSecondarySchoolContentsNew-->
      @if (previewCollection.vocationalDegrees?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.vocationalDegrees.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (degree of previewCollection.vocationalDegrees; track degree; let isLast = $last) {
            {{ degree.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--vocationalDegrees-->
      @if (previewCollection.vocationalUnits?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.vocationalUnits.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (unit of previewCollection.vocationalUnits; track unit; let isLast = $last) {
            {{ unit.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--vocationalUnits-->
      @if (previewCollection.subjectOfCommonUnit?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.vocationalCommonUnits.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (unit of previewCollection.subjectOfCommonUnit; track unit; let isLast = $last) {
            {{ unit.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--vocationalCommonUnits-->
      @if (previewCollection.vocationalRequirements?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.vocationalEducationObjectives.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (requirement of previewCollection.vocationalRequirements; track requirement; let isLast = $last) {
            {{ requirement.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--vocationalEducationObjectives-->
      @if (previewCollection.vocationalEducationFramework) {
        <dt class="col-sm-3">{{ "forms.collection.educational.vocationalEducationFramework.label" | translate }}</dt>
        <dd class="col-sm-9">{{ previewCollection.vocationalEducationFramework }}</dd>
      }
      <!--vocationalEducationFramework-->
      @if (previewCollection.selfMotivatedEducationSubjects?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.selfMotivatedEducationSubjects.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (subject of previewCollection.selfMotivatedEducationSubjects; track subject; let isLast = $last) {
            {{ subject.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--selfMotivatedEducationSubjects-->
      @if (previewCollection.selfMotivatedEducationObjectives?.length > 0) {
        <dt class="col-sm-3">
          {{ "forms.collection.educational.selfMotivatedEducationObjectives.label" | translate }}
        </dt>
        <dd class="col-sm-9">
          @for (objective of previewCollection.selfMotivatedEducationObjectives; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--selfMotivatedEducationObjectives-->
      @if (previewCollection.scienceBranches?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.scienceBranches.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (branch of previewCollection.scienceBranches; track branch; let isLast = $last) {
            {{ branch.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--scienceBranches-->
      @if (previewCollection.scienceBranchObjectives?.length > 0) {
        <dt class="col-sm-3">{{ "forms.collection.educational.scienceBranchObjectives.label" | translate }}</dt>
        <dd class="col-sm-9">
          @for (objective of previewCollection.scienceBranchObjectives; track objective; let isLast = $last) {
            {{ objective.targetName }}{{ isLast ? "" : ", " }}
          }
        </dd>
      }
      <!--scienceBranchObjectives-->
      @if (previewCollection.higherEducationFramework) {
        <dt class="col-sm-3">{{ "forms.collection.educational.higherEducationFramework.label" | translate }}</dt>
        <dd class="col-sm-9">{{ previewCollection.higherEducationFramework }}</dd>
      }
      <!--higherEducationFramework-->
    </dl>
  </ng-container>
  <!--educational details-->
  <ng-container>
    <h3>{{ "forms.collection.preview.headings.material" | translate }}</h3>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">{{ "forms.collection.preview.materialsAndHeadings" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (materialOrHeading of previewCollection.materialsAndHeadings; track materialOrHeading; let i = $index) {
          <tr>
            <th scope="row">{{ i + 1 }}</th>
            <td>
              @if (materialOrHeading.id) {
                {{ materials.get(materialOrHeading.id).name[lang] }}
              } @else {
                <p class="fw-bold">{{ materialOrHeading.heading }}</p>
                @if (materialOrHeading.description) {
                  <p>{{ materialOrHeading.description }}</p>
                }
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </ng-container>
  <!--materials-->
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-gray" (click)="previous()">
          {{ "forms.common.previous" | translate }}
        </button>
      </div>
      <div class="col-auto">
        <button type="reset" class="btn btn-cancel" (click)="emitAbort()">
          {{ "forms.common.abort" | translate }}
        </button>
      </div>
      @if (!collection.isPublished) {
        <div class="col-auto">
          <button type="button" class="btn btn-gray" [disabled]="form.invalid" (click)="onSubmit(true)">
            {{ "forms.collection.preview.saveUnpublished" | translate }}
          </button>
        </div>
      }
      <div class="col-auto">
        <button type="submit" class="btn btn-blue" [disabled]="form.invalid">
          @if (collection.isPublished) {
            {{ "forms.common.save" | translate }}
          } @else {
            {{ "forms.collection.preview.savePublished" | translate }}
          }
        </button>
      </div>
    </div>
  </form>
}
